import React from 'react';
import {
    RadioComponentSelector,
    RadioComponentLabels,
    RadioSvg,
} from './RadioButton.styled';
import RadioButtonActive from 'src/assets/images/RadioButton.svg';
import RadioButtonDisabled from 'src/assets/images/RadioButtonDisabled.svg';
import RadioButtonInactive from 'src/assets/images/RadioButtonInactive.svg';

const RadioButton = (props) => {
    const {
        isChecked,
        label,
        handleChange,
        value,
        fontFamilyStyle,
        containerStyle,
        fontSize,
        disabled,
        iPadPaddingRight,
        color,
        padding,
        radioComponentAlignItem,
        radioLabelAlignItem,
        radioBtnMarginTop,
        paddingRight,
        id,
        width,
    } = props;
    return (
        <>
            <RadioComponentSelector
                style={containerStyle}
                onClick={() => !disabled && handleChange(value)}
                disabled={disabled}
                iPadPaddingRight={iPadPaddingRight}
                radioComponentAlignItem={radioComponentAlignItem}
                id={id}
                paddingRight={paddingRight}
            >
                <RadioComponentLabels
                    fontSize={fontSize}
                    fontFamilyStyle={fontFamilyStyle}
                    color={color}
                    padding={padding}
                    radioLabelAlignItem={radioLabelAlignItem}
                >
                    {/* <RadioFormElement
                        type="radio"
                        checked={isChecked}
                        onChange={(e) => {
                            //handleChange(e.target.value);
                        }}
                        value={value}
                    ></RadioFormElement> */}
                    <RadioSvg
                        src={
                            isChecked && disabled
                                ? RadioButtonDisabled
                                : isChecked
                                ? RadioButtonActive
                                : RadioButtonInactive
                        }
                        alt="checkbox"
                        width={width}
                        height="auto"
                        marginTop={radioBtnMarginTop}
                    />

                    {label ? <>{label}</> : ''}
                </RadioComponentLabels>
            </RadioComponentSelector>
        </>
    );
};
export default RadioButton;
